/**
 * PrivacyPolicyPanel - 개인정보처리방침 패널
 * 개인정보처리방침 전문 표시 및 동의 관리
 */

// PDF는 public 폴더의 정적 파일을 다운로드

// 개인정보처리방침 버전
export const PRIVACY_POLICY_VERSION = '1.4.1';

// 개인정보처리방침 내용
export const PRIVACY_POLICY_CONTENT = {
  title: '개인정보 처리방침',
  lastUpdated: '2026년 9월 28일',
  effectiveDate: '2026년 2월 7일',

  intro: `e-GIS(이하 "서비스")는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립·공개합니다.`,

  sections: [
    {
      title: '제1조 개인정보의 처리목적',
      content: `① 서비스는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하는 개인정보는 다음 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받습니다.

<strong>회원 가입 및 관리</strong>
회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 만 14세 미만 아동의 개인정보 처리 시 법정대리인의 동의여부 확인, 서비스 부정이용 방지, 각종 고지·통지 등을 목적으로 개인정보를 처리합니다.

<strong>서비스 제공</strong>
GIS 프로젝트 클라우드 저장 및 불러오기, 스토리맵 웹 게시, 사용자 맞춤 서비스 제공 등을 목적으로 개인정보를 처리합니다.

<strong>서비스 개선에 활용</strong>
학교별 이용 통계 분석, 서비스 품질 향상, 신규 서비스 개발을 위한 자료 등의 목적으로 개인정보를 처리합니다.

<strong>실험실 의견 접수</strong>
실험실(검증 중인 기능)에 대해 이용자가 보낸 의견을 확인하여 기능을 개선하고, 이용자가 이메일을 적은 경우 그 의견에 답장하는 목적으로 개인정보를 처리합니다.`
    },
    {
      title: '제2조 처리하는 개인정보 항목',
      content: `① 서비스는 「개인정보 보호법」에 따라 서비스 제공을 위해 필요 최소한의 범위에서 다음의 개인정보 항목을 수집·이용합니다.

<strong>[ 정보주체의 동의를 받아 처리하는 개인정보 항목 ]</strong>

<strong>1. 필수 항목</strong>
• 이메일 주소: 회원 식별 및 로그인, 스토리맵 게시 시 공개 아이디 생성(제6조 제2항)
• 가입 시 확인 결과: 만 14세 이상 여부, 법정대리인 동의 여부 및 확인 방법, 개인정보 처리방침 동의 일시와 동의한 방침 버전 (동의 근거 보관, 제5조)

<strong>2. 선택 항목</strong>
• 이름, 닉네임: 프로필 표시
• 소속 학교, 지역: 학교별 통계 집계

<strong>3. 이용자가 직접 저장·게시하는 항목</strong>
• 클라우드에 저장한 GIS 프로젝트 데이터 (클라우드 저장 기능 사용 시)
• 게시한 스토리맵의 제목·본문·지도 구성, 공개 아이디, 게시 번호, 게시 일시 (스토리맵 게시 기능 사용 시)

<strong>[ 실험실 「의견 보내기」로 받는 항목 (이용자가 직접 보낼 때만, 회원 가입 없이도 가능) ]</strong>
• 필수: 의견을 남길 기능, 기능별 의견 글
• 선택: 첨부한 이미지(화면 캡처), 역할(교사·학생·기타), 답장 받을 이메일 주소
• 보낼 때 함께 전송: 보낸 시각, 켜져 있던 실험 기능, 의견을 보낸 페이지 주소, 브라우저 정보(User-Agent)
• 선택 항목은 적지 않아도 의견을 보낼 수 있습니다. 첨부 이미지나 의견 글에 이름·얼굴 등 개인정보가 들어가지 않도록 유의하시기 바랍니다.

<strong>[ 서비스 이용 과정에서 자동으로 생성되는 항목 ]</strong>
• 접속 IP 주소, 브라우저 종류, 접속 일시 등 접속 기록: 웹사이트 호스팅, 배경지도 표시, 방문자 수 집계 과정에서 해당 수탁자(제7조)의 서버에 전송됩니다. 서비스가 이를 별도로 수집·저장하지는 않습니다.

<strong>[ 로컬 저장 항목 (이용자 기기 내 저장, 서버 미전송) ]</strong>
• GIS 프로젝트 데이터, 레이어 정보, 설정값
• 해당 정보는 이용자 브라우저의 IndexedDB 및 LocalStorage에 저장되며, 이용자가 클라우드 저장 기능을 사용하지 않는 한 서버로 전송되지 않습니다.

② 이용자는 서비스 이용을 위한 개인정보 수집에 대하여 거부할 수 있습니다. 다만, 필수항목은 서비스 이용에 필요한 최소한의 정보이므로 이에 대한 수집 거부 시 회원가입이 제한됩니다.`
    },
    {
      title: '제3조 개인정보의 처리 및 보유기간',
      content: `① 서비스는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보 수집 시에 동의받은 보유·이용기간 내에서 개인정보를 처리·보유합니다.

② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.

<strong>회원 정보 (이메일, 프로필, 가입 시 확인 결과)</strong>
• 회원 탈퇴 시까지

<strong>프로젝트 데이터 (클라우드 저장)</strong>
• 이용자가 삭제하거나 회원 탈퇴 시까지

<strong>게시한 스토리맵</strong>
• 이용자가 게시를 취소하거나 회원 탈퇴 시까지

<strong>실험실 의견 (의견 글, 첨부 이미지, 역할, 이메일 등)</strong>
• 접수일로부터 1년이 지나거나, 이용자가 삭제를 요청할 때까지

<strong>로컬 저장 데이터</strong>
• 브라우저 데이터 삭제 시까지

다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지
• 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지

③ 서비스는 이용자의 개인정보를 개인정보 처리목적에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 고지한 범위를 초과하여 이용하거나 이용자의 개인정보를 외부에 공개하지 않습니다. 다만 아래의 경우에는 예외로 합니다.
• 이용자가 사전에 동의한 경우
• 이용자가 스토리맵 게시 기능으로 직접 공개한 경우 (제6조 제2항)
• 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우`
    },
    {
      title: '제4조 개인정보의 파기 절차 및 방법',
      content: `① 서비스는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.

② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.

③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.

<strong>파기 절차</strong>
서비스는 파기 사유가 발생한 개인정보를 선정하고, 개인정보 보호책임자의 승인을 거쳐 개인정보를 파기합니다. 이용자가 회원 탈퇴를 실행하면 계정·프로필·프로젝트·게시한 스토리맵이 즉시 함께 파기됩니다.

<strong>파기 방법</strong>
• 클라우드 데이터(회원 정보·프로젝트·게시한 스토리맵): Supabase 데이터베이스에서 기록을 재생할 수 없도록 영구 삭제
• 실험실 의견: 의견이 기록된 구글 스프레드시트의 행과 구글 드라이브에 저장된 첨부 이미지를 삭제하고 휴지통에서도 영구 삭제
• 로컬 데이터: 브라우저 저장소(IndexedDB, LocalStorage) 초기화를 통한 삭제`
    },
    {
      title: '제5조 만 14세 미만 아동의 개인정보 보호',
      content: `① 서비스는 만 14세 미만 아동의 개인정보를 처리하기 위하여 동의가 필요한 경우에는 해당 아동의 법정대리인으로부터 동의를 받습니다.

② 서비스는 회원가입 화면에서 이용자가 만 14세 이상인지를 확인합니다. 만 14세 미만인 경우에는 법정대리인의 동의를 받았음을 확인한 경우에만 가입이 진행되며, 확인 결과(만 14세 이상 여부, 법정대리인 동의 여부, 동의 확인 방법)는 가입 시점에 회원 정보와 함께 기록·보관됩니다(제2조 제1호).

③ 서비스는 만 14세 미만 아동의 개인정보 처리에 관하여 법정대리인의 동의를 받을 때에는 학기 초 학교 가정통신문(개인정보 수집·이용 동의서)을 통해 법정대리인의 동의를 받습니다. 교사는 학생들의 서비스 이용 전 법정대리인 동의를 받을 책임이 있습니다.

④ 법정대리인은 만 14세 미만 아동의 개인정보에 대하여 열람, 정정·삭제, 처리정지 요구 등의 권리를 아동을 대신하여 행사할 수 있습니다.`
    },
    {
      title: '제6조 개인정보의 제3자 제공 및 공개',
      content: `① 서비스는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.

② 이용자가 스토리맵 도구(e-GIStory)의 게시 기능을 사용하면, 해당 스토리맵은 e-gis.kr/{공개 아이디}/{게시 번호} 주소로 누구나 열람할 수 있게 공개됩니다. 게시는 이용자가 직접 실행할 때만 이루어지며, 다음 사항에 유의하시기 바랍니다.
• 공개 아이디는 이용자의 이메일 주소에서 '@' 앞부분과 도메인의 첫 단어를 이어 붙인 뒤 영문 소문자·숫자만 남겨 만듭니다(예: abc123@school.ac.kr → abc123school). 따라서 게시 주소에 이메일 주소의 일부가 드러납니다.
• 게시한 스토리맵의 제목·본문·이미지·지도 구성은 그대로 공개됩니다. 본문에 이름, 사진 등 개인정보가 들어 있지 않은지 게시 전에 확인하시기 바랍니다.
• 이용자는 언제든지 게시를 취소할 수 있으며, 취소 즉시 해당 주소에서 열람할 수 없게 됩니다. 회원 탈퇴 시 게시한 스토리맵은 모두 삭제됩니다.`
    },
    {
      title: '제7조 개인정보처리의 위탁',
      content: `① 서비스는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.

<strong>1. Supabase, Inc.</strong>
• 위탁하는 업무 내용: 사용자 인증 및 클라우드 데이터베이스 운영·관리
• 이전되는 항목: 이메일 주소, 프로필(이름·닉네임·소속 학교·지역), 가입 시 확인 결과, 저장한 프로젝트 데이터, 게시한 스토리맵
• 이전 국가: 미국 (서버 소재지)
• 이전 시기 및 방법: 서비스 이용 시점에 네트워크를 통한 전송
• 개인정보 보유 및 이용기간: 회원 탈퇴 시 또는 위탁계약 종료 시까지

<strong>2. Vercel, Inc.</strong>
• 위탁하는 업무 내용: 웹사이트 호스팅 및 공공데이터 중계 기능(서버 함수) 운영
• 이전되는 항목: 접속 시 발생하는 IP 주소, 브라우저 정보 등 접속 기록 (회원 정보는 전송하지 않음)
• 이전 국가: 미국 (본사 소재지, 서버는 세계 각지의 엣지 네트워크)
• 이전 시기 및 방법: 서비스 접속 시점에 네트워크를 통한 전송
• 개인정보 보유 및 이용기간: 위탁계약 종료 시까지 (접속 기록은 Vercel의 로그 보관 정책에 따라 처리)

<strong>3. Google LLC (Google Apps Script, Google 스프레드시트, Google 드라이브, Gmail)</strong>
• 위탁하는 업무 내용: 방문자 수 집계, 실험실 의견 저장 및 개인정보 보호책임자에게 보내는 접수 알림 메일
• 이전되는 항목: 방문자 수 집계 — 접속 시 발생하는 IP 주소 등 접속 정보 (이용자를 식별하는 정보는 전송하지 않음) / 실험실 의견 — 제2조의 「의견 보내기」 항목(선택 항목은 이용자가 입력한 경우만)
• 이전 국가: 미국 (서버 소재지)
• 이전 시기 및 방법: 방문자 수 집계는 서비스 접속 시점, 실험실 의견은 이용자가 의견을 보내는 시점에 네트워크를 통한 전송
• 개인정보 보유 및 이용기간: 방문자 수 집계는 집계 목적 달성 시까지, 실험실 의견은 제3조의 보유기간까지

<strong>4. OpenStreetMap Foundation (Nominatim)</strong>
• 위탁하는 업무 내용: 위치 검색(지오코딩) 및 좌표→주소 변환
• 이전되는 항목: 이용자가 입력한 검색어, '현재 위치' 기능 사용 시 해당 좌표, 접속 IP 주소
• 이전 국가: 영국·독일 등 (서버 소재지)
• 이전 시기 및 방법: 위치 검색 기능 사용 시점에 네트워크를 통한 전송
• 개인정보 보유 및 이용기간: 요청 처리 시까지

<strong>5. 배경지도 타일 제공자 — 국토교통부 브이월드(VWorld), OpenStreetMap Foundation, OpenTopoMap, CARTO, Esri</strong>
• 위탁하는 업무 내용: 배경지도 타일(일반·흰색·야간 지도, 지형도, 위성 영상, 지명 라벨) 제공
• 이전되는 항목: 접속 IP 주소, 접속 도메인, 화면에 표시 중인 지도 영역(타일 좌표·확대 수준) 등 접속 정보
• 이전 국가: 대한민국(브이월드), 영국 등(OpenStreetMap Foundation), 독일(OpenTopoMap), 미국(CARTO, Esri) (서버 소재지)
• 이전 시기 및 방법: 지도를 표시하는 동안 브라우저가 타일을 요청하는 시점에 네트워크를 통한 전송
• 개인정보 보유 및 이용기간: 요청 처리 시까지 (각 제공자의 정책에 따름)

※ 위 2~5번에는 회원 정보(이메일·이름·소속 학교 등)가 전송되지 않으며, 4번은 위치 검색 기능을 사용할 때만 전송이 발생합니다. 3번의 실험실 의견에 포함되는 이메일은 회원 정보가 아니라 이용자가 의견 창에 직접 적은 경우에만 전송됩니다.

② 서비스는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 안전성 확보조치, 기술적·관리적 보호조치, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.

③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.

④ 이용자는 회원 탈퇴 또는 서비스 이용 중단을 통해 국외 이전을 거부할 수 있으며, 회원 탈퇴 시 클라우드 저장·스토리맵 게시 서비스 이용이 제한됩니다.`
    },
    {
      title: '제8조 개인정보 자동 수집 장치의 운영 및 거부',
      content: `① 서비스는 이용자의 편의를 위해 브라우저 로컬 저장소(LocalStorage, IndexedDB)를 사용하여 설정값과 프로젝트 데이터를 저장합니다.

② 로컬 저장소에 보관된 설정값과 프로젝트 데이터는 이용자의 기기에만 저장되며, 이용자가 클라우드 저장 기능을 사용하지 않는 한 서버로 전송되지 않습니다. 이용자는 브라우저 설정을 통해 저장된 데이터를 삭제할 수 있습니다.

③ 서비스는 방문자 수 집계를 위해 접속 시 1일 1회 외부 집계 서버(제7조 제3호)에 요청을 보냅니다. 이때 이용자를 식별하는 정보는 전송하지 않으며, 같은 기기의 중복 집계를 막기 위한 방문 일자만 브라우저 로컬 저장소에 기록합니다.

④ 서비스는 별도의 쿠키(cookie)를 사용하지 않습니다. 다만, 인증 서비스 제공을 위해 Supabase에서 인증 토큰을 로컬 저장소에 저장할 수 있습니다.

▶ 브라우저에서 로컬 저장소 데이터 삭제
• 크롬(Chrome): 웹 브라우저 설정 > 개인정보 보호 및 보안 > 인터넷 사용 기록 삭제
• 엣지(Edge): 웹 브라우저 설정 > 쿠키 및 사이트 권한 > 쿠키 및 사이트 데이터 관리 및 삭제
• 웨일(Whale): 웹 브라우저 설정 > 개인정보 보호 > 인터넷 사용 기록 삭제`
    },
    {
      title: '제9조 정보주체와 법정대리인의 권리·의무 및 행사방법',
      content: `① 정보주체는 서비스에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
• 개인정보의 처리에 관한 정보를 받을 권리
• 개인정보의 처리에 관한 동의 여부, 동의 범위 등을 선택하고 결정할 권리
• 개인정보 처리 여부를 확인하고 개인정보에 대하여 열람(사본 발급 포함)을 요구할 권리
• 개인정보의 처리 정지, 정정·삭제 및 파기를 요구할 권리

② 권리 행사는 서비스에 대해 서면, 전자우편 등을 통하여 하실 수 있으며 서비스는 이에 대해 지체 없이 조치하겠습니다.

③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 서비스는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.

④ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다.

⑤ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.

⑥ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 삭제를 요구할 수 없습니다.

<strong>권리 행사 방법</strong>
• 마이페이지 > 개인정보 관리에서 직접 열람·수정 가능
• 회원탈퇴 기능을 통해 계정·프로필·프로젝트·게시한 스토리맵을 즉시 삭제 가능
• 게시한 스토리맵은 게시 취소 기능으로 즉시 비공개 처리 가능
• 보낸 실험실 의견의 열람·삭제는 이메일로 요청 (보낸 날짜와 의견 내용 일부를 알려 주시면 찾아 처리)
• 이메일(bgnlkim@gmail.com)로 요청 시 지체 없이 조치`
    },
    {
      title: '제10조 개인정보의 안전성 확보 조치',
      content: `① 서비스는 「개인정보 보호법」 제29조에 따라 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.

<strong>관리적 조치</strong>
• 개인정보 취급 직원의 최소화
• 정기적인 자체 점검 실시

<strong>기술적 조치</strong>
• 비밀번호 암호화: 이용자의 비밀번호는 암호화되어 저장
• 전송 구간 암호화: 전 구간 HTTPS 암호화 통신 적용(HTTP 접속은 HTTPS로 자동 전환), TLS 1.3 사용
• 접근 권한 관리: 데이터베이스 행 수준 보안(RLS) 적용으로 이용자는 자신의 데이터에만 접근 가능
• 웹 보안 헤더 적용: Content-Security-Policy(악성 스크립트 삽입 차단), X-Frame-Options(클릭재킹 차단), X-Content-Type-Options, Referrer-Policy, Permissions-Policy
• 이용자가 입력한 이름이 화면에 표시될 때 스크립트로 실행되지 않도록 처리

<strong>물리적 조치</strong>
• 개인정보는 별도의 자체 서버 없이 수탁자(제7조)의 데이터센터에 보관하며, 해당 데이터센터의 물리적 접근통제 조치를 따릅니다.`
    },
    {
      title: '제11조 개인정보 보호 책임자 안내',
      content: `① 서비스는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

<strong>개인정보 보호책임자</strong>
• 성명: 김용현
• 직위: 개발자
• 이메일: bgnlkim@gmail.com

② 정보주체는 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다. 서비스는 정보주체의 문의에 대해 지체 없이 답변 및 처리해 드릴 것입니다.`
    },
    {
      title: '제12조 개인정보 처리방침의 변경',
      content: `① 이 개인정보 처리방침은 2026년 2월 7일에 최초 시행되었으며, 현재 버전(1.4.1)은 2026년 9월 28일부터 적용됩니다.

② 이 개인정보 처리방침은 법령, 정책 또는 보안기술의 변경에 따라 내용이 추가, 삭제 및 수정될 수 있습니다. 변경 시에는 변경사항 시행 7일 전부터 서비스 내 공지사항을 통해 고지할 것입니다.

<strong>③ 개정 이력</strong>
• 1.0.0 (2026년 2월 7일): 최초 수립·시행
• 1.1.0 (2026년 3월 17일): 조문 순서 정비(만 14세 미만 아동 조항 등), 버전·시행일·최종 수정일 표기 추가
• 1.2.0 (2026년 8월 15일): 만 14세 확인 절차 구체화, 위탁 항목(방문자 집계·위치 검색·경로 분석) 추가, 안전성 확보 조치 현행화
• 1.3.0 (2026년 9월 14일): 경로·등시선 분석의 외부 위탁(OpenRouteService) 삭제 — 내장 도로망으로 대체되어 외부 전송 없음, 스토리맵 게시에 따른 공개 안내 추가, 호스팅(Vercel)·배경지도 타일 제공자 위탁 추가, 가입 시 확인 결과를 수집 항목에 명시, 회원 탈퇴 시 삭제 범위 명시
• 1.3.1 (2026년 9월 14일): 배경지도 타일 제공자에 국토교통부 브이월드(VWorld)·OpenTopoMap 추가
• 1.4.0 (2026년 9월 28일): 실험실 「의견 보내기」 추가 — 처리 목적·수집 항목(선택 항목인 이메일·첨부 이미지 포함)·보유기간·파기 방법 명시, Google 위탁 업무에 의견 저장(스프레드시트·드라이브) 추가, 의견 열람·삭제 요청 방법 추가
• 1.4.1 (2026년 9월 28일): 실험실 의견 보유기간을 1년으로 단축, 의견 접수 알림 메일(Gmail) 위탁 업무에 추가`
    },
    {
      title: '제13조 권익침해 구제방법',
      content: `① 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.

• <strong>개인정보분쟁조정위원회</strong>: (국번없이) 1833-6972 (www.kopico.go.kr)
• <strong>개인정보침해신고센터</strong>: (국번없이) 118 (privacy.kisa.or.kr)
• <strong>대검찰청</strong>: (국번없이) 1301 (www.spo.go.kr)
• <strong>경찰청</strong>: (국번없이) 182 (ecrm.cyber.go.kr)

② 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.
※ 행정심판에 대해 자세한 사항은 중앙행정심판위원회(www.simpan.go.kr) 홈페이지를 참고하시기 바랍니다.`
    },
    {
      title: '제14조 개인정보 열람청구',
      content: `① 정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 담당자에게 할 수 있습니다. 서비스는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.

▶ 개인정보 열람청구 접수·처리 담당자
• 성명: 김용현
• 직위: 개발자
• 연락처: bgnlkim@gmail.com`
    }
  ]
};

class PrivacyPolicyPanel {
  constructor() {
    this.modal = null;
  }

  /**
   * 패널 열기
   */
  show() {
    this.render();
  }

  /**
   * 모달 렌더링
   */
  render() {
    this.close();

    this.modal = document.createElement('div');
    this.modal.className = 'modal-overlay privacy-modal active';

    this.modal.innerHTML = `
      <div class="modal-content privacy-content">
        <div class="modal-header">
          <h3>${PRIVACY_POLICY_CONTENT.title}</h3>
          <button class="modal-close" id="privacy-close">&times;</button>
        </div>
        <div class="modal-body privacy-body">
          <div class="privacy-meta">
            <span>버전: ${PRIVACY_POLICY_VERSION}</span>
            <span>최종 수정: ${PRIVACY_POLICY_CONTENT.lastUpdated}</span>
          </div>
          <div class="privacy-intro">${PRIVACY_POLICY_CONTENT.intro}</div>
          <div class="privacy-sections">
            ${PRIVACY_POLICY_CONTENT.sections.map(section => `
              <div class="privacy-section">
                <h4>${section.title}</h4>
                <div class="privacy-section-content">${section.content.replace(/\n/g, '<br>')}</div>
              </div>
            `).join('')}
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" id="privacy-download-pdf">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            PDF 다운로드
          </button>
          <button class="btn btn-primary" id="privacy-confirm">확인</button>
        </div>
      </div>
    `;

    document.body.appendChild(this.modal);
    this.bindEvents();
  }

  /**
   * 간단 요약 버전 HTML 반환 (회원가입 모달용)
   */
  getSummaryHTML() {
    return `
      <div class="privacy-summary">
        <div class="privacy-summary-title">개인정보 수집·이용 동의 (필수)</div>
        <div class="privacy-summary-content">
          <div class="privacy-summary-item">
            <span class="privacy-label">수집 항목</span>
            <span class="privacy-value">이메일 주소</span>
          </div>
          <div class="privacy-summary-item">
            <span class="privacy-label">수집 목적</span>
            <span class="privacy-value">회원 식별, 클라우드 저장 서비스 제공</span>
          </div>
          <div class="privacy-summary-item">
            <span class="privacy-label">보유 기간</span>
            <span class="privacy-value">회원 탈퇴 시까지</span>
          </div>
        </div>
        <button type="button" class="btn btn-outline privacy-full-btn" id="show-full-privacy">
          전문 보기
        </button>
      </div>
    `;
  }

  /**
   * 이벤트 바인딩
   */
  bindEvents() {
    const closeBtn = document.getElementById('privacy-close');
    const confirmBtn = document.getElementById('privacy-confirm');
    const downloadBtn = document.getElementById('privacy-download-pdf');

    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    if (confirmBtn) confirmBtn.addEventListener('click', () => this.close());
    if (downloadBtn) downloadBtn.addEventListener('click', () => this.downloadPDF());

    // 모달 외부 클릭 시 닫기
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.close();
      }
    });
  }

  /**
   * PDF 다운로드
   */
  downloadPDF() {
    const link = document.createElement('a');
    link.href = `${import.meta.env.BASE_URL}privacy-policy.pdf`;
    link.download = '개인정보 처리방침(e-GIS).pdf';
    link.click();
  }

  /**
   * 모달 닫기
   */
  close() {
    if (this.modal) {
      this.modal.remove();
      this.modal = null;
    }
  }
}

export const privacyPolicyPanel = new PrivacyPolicyPanel();
